import React, { useState } from "react";
import styles from "./TimeInput.module.scss";
import { Controller } from "react-hook-form";
import withLabelAndError from "../withLabelAndError";
import { combineClasses } from "@/lib/utils";
import {
  InputControlProps,
  WithLabelAndErrorComponent,
} from "@/types/formControls";

import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import dayjs, { Dayjs } from "dayjs";
import { IconButton, InputAdornment } from "@mui/material";
import ClockIcon from "@/components/SVGComponents/ModalIcons/ClockIcon";

const TimeInput: React.FC<InputControlProps> = (props) => {
  const {
    control,
    register,
    validations,
    name,
    placeholder,
    error,
    className,
    ...rest
  } = props;

  const [open, setOpen] = useState(false);

  const pickerSlotProps = {
    sx: {
      "& .Mui-selected": {
        backgroundColor: "rgb(var(--secondary-color)) !important",
        color: "white !important",
      },
      "& .Mui-selected:hover": {
        backgroundColor: "rgb(var(--secondary-color)) !important",
      },
      "& .MuiMenuItem-root.Mui-selected": {
        backgroundColor: "rgb(var(--secondary-color)) !important",
        color: "white !important",
      },
      "& .MuiMultiSectionDigitalClockSection-item.Mui-selected": {
        backgroundColor: "rgb(var(--secondary-color)) !important",
        color: "white !important",
      },
      "& .MuiMultiSectionDigitalClockSection-root": {
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
      },
      "& .MuiList-root, & .MuiDigitalClock-list": {
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
      },
    },
  };

  const renderTimePicker = (field: any = {}) => (
    <TimePicker
      {...field}
      value={field.value ? dayjs(field.value, "HH:mm") : null}
      format="HH:mm" // 24-hour format
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      onChange={(time: Dayjs | null) => {
        field.onChange(time ? time.format("HH:mm") : null);
      }}
      {...rest}
      slotProps={{
        ...(rest as any).slotProps,
        popper: pickerSlotProps,
        desktopPaper: pickerSlotProps,
        mobilePaper: pickerSlotProps,
        textField: {
          label: "",
          fullWidth: true,
          placeholder: placeholder || "Select time",
          error: !!error,
          helperText: error?.message,
          className: combineClasses(styles.inputRoot, className),
          onClick: () => setOpen(true),

          InputProps: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  onClick={() => setOpen(true)}
                  tabIndex={-1}
                >
                  <ClockIcon height="18" width="18" />
                </IconButton>
              </InputAdornment>
            ),
          },
        },
      }}
    />
  );

  if (control) {
    return (
      <Controller
        control={control}
        rules={validations}
        name={name}
        render={({ field }) => renderTimePicker(field)}
      />
    );
  } else {
    const field = register?.(name, validations);
    return renderTimePicker(field);
  }
};

const TimeInputWithLabelAndError = withLabelAndError(
  TimeInput as WithLabelAndErrorComponent
);

export default TimeInputWithLabelAndError;
export { TimeInput };